import React from "react";
import { connect } from "react-redux";
import { CetificateLandingContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { Buttons, Displays } from "components";
import { withTranslation } from "react-i18next";
import { GENERAET_CERIFICATE } from "utils/functions/certificate";

/**
 * หน้าปลายทางของปุ่ม Download ในอีเมล — /certificate/:generateHistoryId
 *
 * เดิมหน้านี้ไม่ render อะไรเลยนอกจาก spinner แล้วเด้ง AlertControl ที่ปิดไม่ได้
 * (isForceSelect: true แต่ไม่มีปุ่ม) ทั้งที่ข้อความบอกให้ "คลิกปุ่ม Download"
 * ซึ่งไม่มีอยู่จริงบนหน้า → ลูกค้าค้างอยู่ตรงนั้น ออกไปไหนไม่ได้
 *
 * ตอนนี้แสดงตัวใบให้เห็น + ปุ่มดาวน์โหลดจริง และมีสถานะ error ที่กดออกได้
 */
class CetificateLandingContainer extends React.Component {
  state = {
    isLoading: true,
    isError: false,
    imageData: null,
  };

  componentDidMount() {
    this.fetchCertificate();
  }

  fetchCertificate = async () => {
    const { router } = this.props;
    this.setState({ isLoading: true, isError: false });
    let res = await GENERAET_CERIFICATE(router.params?.id);
    if (res && res.status === 200) {
      this.setState({ imageData: res.data, isLoading: false, isError: false });
      // ลองยิงดาวน์โหลดให้อัตโนมัติ แต่ห้ามพึ่งอย่างเดียว
      // in-app browser (LINE / IG) บล็อก <a download> เป็นเรื่องปกติ
      // ปุ่มบนหน้าคือทางที่ใช้ได้จริงเสมอ
      this.handleDownload(res.data);
    } else {
      this.setState({ isLoading: false, isError: true });
    }
  };

  handleDownload = (imageData) => {
    const data = imageData || this.state.imageData;
    if (!data) return;
    const link = document.createElement("a");
    link.download = "certificate.png";
    link.href = data;
    link.click();
  };

  handleGoHome = () => {
    this.props.router.navigate("/");
  };

  render() {
    const { t } = this.props;
    const { isLoading, isError, imageData } = this.state;
    return (
      <CetificateLandingContainerStyled>
        <div className="certificate_container">
          {isLoading ? (
            <Displays.Loading />
          ) : isError ? (
            <div className="cl_message_block">
              <div className="cl_title">
                {t("Notification", { ns: "common" })}
              </div>
              <div className="cl_desc">
                {t("Download failed. Please contact support.", {
                  ns: "common",
                })}
              </div>
              <div className="cl_btn_wrap">
                <Buttons.BgStandard
                  label={t("Try again", { ns: "common" })}
                  onClick={this.fetchCertificate}
                />
              </div>
              <div className="cl_btn_wrap">
                <Buttons.BgStandard
                  theme_gray
                  label={t("Home", { ns: "common" })}
                  onClick={this.handleGoHome}
                />
              </div>
            </div>
          ) : (
            <>
              <div className="cl_preview_wrap">
                <img
                  className="cl_preview"
                  src={imageData}
                  alt="certificate"
                />
              </div>
              <div className="cl_btn_wrap">
                <Buttons.BgStandard
                  label={t("Download", { ns: "common" })}
                  onClick={() => this.handleDownload()}
                />
              </div>
              <div className="cl_hint">
                {t("If the download does not start, press and hold the image to save it.", {
                  ns: "common",
                })}
              </div>
              {/* หน้านี้เข้าจากลิงก์ในอีเมล ไม่มีเมนูล่างและอาจยังไม่ได้ล็อกอิน
                  ถ้าไม่มีปุ่มนี้ ลูกค้าจะติดอยู่หน้านี้ ไปไหนไม่ได้เลย
                  "/" ตกไปที่ SplashContainer ซึ่งพาไป login หรือหน้าหลักให้เอง */}
              <div className="cl_btn_wrap cl_btn_home">
                <Buttons.BgStandard
                  theme_gray
                  label={t("Home", { ns: "common" })}
                  onClick={this.handleGoHome}
                />
              </div>
            </>
          )}
        </div>
      </CetificateLandingContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(["common"])(withRouter(CetificateLandingContainer)));
